import React from 'react';
import _ from 'lodash';

import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { withStyles } from '@material-ui/core/styles';

import {
    createStyles, WithStyles, Paper, TableHead, Button, Link, Grid, Typography
} from '@material-ui/core';

const styles = (theme: Theme) => createStyles({
    root: {
        background: 'rgb(255 255 255)',
        boxShadow: '0px 2px 20px rgba(0, 0, 0, 0.12)',
        margin: '-15px -15px',
        padding: '12px 26px'
    },
    headingFont: {
        fontWeight: 600,
        fontSize: 36,
        color: '#333333'
    }
});


interface UserHeaderProps extends WithStyles<typeof styles> {
    classes: any,
}

const handleChangePage = () => {

}

const UserHeader = (props: UserHeaderProps) => {
    const {
        classes
    } = props;
    //@ts-ignore

    const handleChangeRowsPerPage = (event: any) => {
        // this.setState({ page: 0, rowsPerPage: event.target.value });
    };

    return (
        <>
            <Grid className={classes.root}>
                <Grid container justify="space-between" alignItems="center">
                    <Grid item>
                        <Typography className={classes.headingFont}>Clients</Typography>
                    </Grid>
                    <Grid item>
                        <Button variant="contained"
                            color="primary">
                                Add New Client</Button>
                    </Grid>
                </Grid>
            </Grid>
        </>

    );
};

export default withStyles(styles)(UserHeader);